import request from '@/utils/request'

const prefix = '/django_rest/v-admin'
export default {
  getSchedulerJobList (params) {
    return request.get(`${prefix}/ap-scheduler/`, { params })
  },
  getSchedulerJobDetail (params) {
    return request.get(`${prefix}/ap-scheduler/${params.id}`, { params })
  },
  getJobSyncDetailInfo (params) {
    return request.get(`${prefix}/ap-scheduler/${params.id}/job-info/`, { params })
  },
  getApplicationSyncDetailInfo (params) {
    return request.get(`${prefix}/ap-scheduler/${params.id}/application-info/`, { params })
  },
  getApplicationStatusSyncDetailInfo (params) {
    return request.get(`${prefix}/ap-scheduler/${params.id}/application-status-info/`, { params })
  },
  getSchedulerStatus () {
    return request.get(`${prefix}/ap-scheduler/status/`)
  },
  getSchedulerCount (params) {
    return request.get(`${prefix}/ap-scheduler/count/`, { params })
  },
  setSchedulerTaskInfo (params) {
    return request.put(`${prefix}/ap-scheduler/task/${params.task_id}`, params)
  },
  batchSetSchedulerTaskInfo () {
    return request.put(`${prefix}/ap-scheduler/batch/task/`)
  },
  getIntegrationCompany () {
    return request.get(`${prefix}/integration/company/`)
  },
  getJobSyncDetailInfoByHistoryId (historyId) {
    return request.get(`${prefix}/integration/${historyId}/job-info/`)
  },
  getApplicationSyncDetailInfoByHistoryId (historyId) {
    return request.get(`${prefix}/integration/${historyId}/application-info/`)
  },
  getApplicationStatusSyncDetailInfoByHistoryId (historyId) {
    return request.get(`${prefix}/integration/${historyId}/application-status-info/`)
  },
  getEmployeeSyncDetailInfoByHistoryId (historyId) {
    return request.get(`${prefix}/integration/${historyId}/employee-info/`)
  },
  retryApplicationIntegration (params) {
    return request.post(`${prefix}/integration/retry-application/`, params)
  },
  createExportApplicationSyncRecordTask (params) {
    return request.post(`${prefix}/integration/application-sync-export/`, params)
  },
  getExportApplicationSyncRecordTaskInfo (params) {
    return request.get(`${prefix}/integration/application-sync-export/`, { params })
  },
  createExportApplicationStatusSyncRecordTask (params) {
    return request.post(`${prefix}/integration/application-status-sync-export/`, params)
  },
  getExportApplicationStatusSyncRecordTaskInfo (params) {
    return request.get(`${prefix}/integration/application-status-sync-export/`, { params })
  },
  getIntegrationErrorRecordList (params) {
    return request.get(`${prefix}/integration/error-record/`, { params })
  },
  markIntegrationErrorRecordProcessed (params) {
    return request.post(`${prefix}/integration/error-record/`, params)
  },
  createExportIntegrationErrorRecordTask (params) {
    return request.post(`${prefix}/integration/error-record-export/`, params)
  },
  getExportIntegrationErrorRecordTaskInfo (params) {
    return request.get(`${prefix}/integration/error-record-export/`, { params })
  }
}
